// extracted by mini-css-extract-plugin
export var hidden = "_5a-1";
export var leftPanel = "_5a-2";
export var readonlyInspector = "_5a-3";
export var rightPanel = "_5a-0";